// eslint-disable-next-line no-shadow
export enum SubscriptionPlanType {
	MONTHLY = 'monthly',
	ANNUALLY = 'annually',
	ONE_TIME = 'one_time',
}
